<form [formGroup]="conditionnementForm" (ngSubmit)="addConditionnement()">
  <div class="form-container">
    <div class="form-field">
      <label>{{'referentiels.list.conditionnementProperties.codeHecate.header' | transloco }}<span class="required">*</span></label>
      <input pInputText type="number" formControlName="codeHecate" />
      <small class="p-error block">
        @if (conditionnementForm.controls.codeHecate.errors?.required) {
          <p-message *ngIf="conditionnementForm.controls['codeHecate'].invalid && conditionnementForm.controls['codeHecate'].touched" severity="danger" text="Le code hecate est requis."></p-message>
        } @else if (conditionnementForm.controls.codeHecate.errors?.maxlength) {
          <p-message *ngIf="conditionnementForm.controls['codeHecate'].invalid && conditionnementForm.controls['codeHecate'].touched" severity="danger" text="La désignation ne doit pas dépasser 10 caractères."></p-message>
        }
      </small>
    </div>

    <div class="form-field">
      <label>{{ 'referentiels.list.conditionnementProperties.designation.header'| transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="designation" />
      <small class="p-error block">
        <p-message *ngIf="conditionnementForm.controls['designation'].invalid && conditionnementForm.controls['designation'].touched" severity="danger" text="Le champ pour la désignation est requis."></p-message>
      </small>
    </div>
  </div>

  <div class="button-container">
    <p-button [rounded]="true" pRipple label="{{ 'button.cancel' | transloco }}" (onClick)="close(false)" />
    <p-button [rounded]="true" pRipple label="{{ 'button.validate' | transloco}}" type="submit" [disabled]="conditionnementForm.invalid" />
  </div>

  <div *ngIf="submitting" class="loading-spinner">
    <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
  </div>
</form>
<p-toast />
